// extracted by mini-css-extract-plugin
module.exports = {"app":"zeus_common_tools_app__3JN2K"};